import React from 'react';

function ClosestDealersHeader({ translations }) {
    return (
        <h3>{translations.closestDealersHeading}</h3>
    );
}

export { ClosestDealersHeader };